const initSliders = () => {

    new Swiper('.topbar__slider', {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 2500
        }
    })

    new Swiper('.related-posts__slider', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        initialSlide: 0,
        centeredSlides: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
                centeredSlides: false,
            },
            1024: {
                spaceBetween: 32,
                slidesPerView: 3,
                centeredSlides: false,
            }
        },
        pagination: {
            el: '.related-posts__pagination',
            clickable: true,
        }
    })

    new Swiper('.content-with-items__slider', {
        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: false,
        initialSlide: 0,
        pagination: {
            el: '.content-with-items__pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                centeredSlides: false,
            },
            1024: {
                spaceBetween: 32,
                slidesPerView: 4,
                centeredSlides: false,
            }
        }
    })

    new Swiper('.content-with-images__slider', {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        initialSlide: 0,
        pagination: {
            el: '.content-with-images__pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                spaceBetween: 30,
                slidesPerView: 2,
                centeredSlides: false,
            },
            1024: {
                spaceBetween: 32,
                slidesPerView: 2,
                centeredSlides: false,
            },
            1220: {
                spaceBetween: 32,
                slidesPerView: 3,
                centeredSlides: false,
            }
        }
    })

    new Swiper('.gallery-slider__slider', {
        slidesPerView: 'auto',
        spaceBetween: 24,
        centeredSlides: false,
        navigation: {
            nextEl: '.gallery-slider__button-next',
            prevEl: '.gallery-slider__button-prev'
        },
        pagination: {
            el: '.gallery-slider__pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1024: {
                spaceBetween: 32,
                slidesPerView: 4,
            }
        }
    })

    new Swiper('.posts-slider__slider', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        initialSlide: 0,
        centeredSlides: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
                centeredSlides: false,
            },
            1024: {
                spaceBetween: 32,
                slidesPerView: 3,
                centeredSlides: false,
            }
        },
        pagination: {
            el: '.posts-slider__pagination',
            clickable: true,
        }
    })

};

export { initSliders };
